import React from 'react';
import { useTranslation } from 'react-i18next';
import './ContactDetails.css';
import { ArrowIcon, Magnetic, Reveal, SplitText } from './motion';
import { useConsent } from './Consent';
import { COMPANY, TEAM } from '../data/site';

const ContactDetails = () => {
  const { t } = useTranslation();
  const consent = useConsent();
  const mailto = `mailto:${COMPANY.email}?subject=${encodeURIComponent(t('contact.subject'))}`;

  const details = [
    { label: t('contact.phone'), value: COMPANY.phone, href: COMPANY.phoneHref },
    { label: t('contact.email'), value: COMPANY.email, href: `mailto:${COMPANY.email}` },
    { label: t('contact.address'), value: COMPANY.address, href: COMPANY.mapsUrl, external: true },
    { label: t('contact.ico'), value: COMPANY.ico },
    { label: t('contact.dic'), value: COMPANY.dic },
  ];

  return (
    <section id="contact" className="section section--dark contact">
      <div className="container">
        <div className="contact__head">
          <SplitText text={t('contact.title')} className="contact__title" stagger={0.05} />
          <div className="contact__lead">
            <Reveal as="p" delay={0.1}>
              {t('contact.desc')}
            </Reveal>
            <Reveal delay={0.2}>
              <Magnetic strength={0.4}>
                <a href={mailto} className="contact__cta">
                  <span>{t('contact.cta')}</span>
                  <ArrowIcon />
                </a>
              </Magnetic>
            </Reveal>
          </div>
        </div>

        <div className="contact__grid">
          <dl className="contact__details">
            {details.map((d, i) => (
              <Reveal key={d.label} className="contact__row" delay={i * 0.06} y={20}>
                <dt>{d.label}</dt>
                <dd>
                  {d.href ? (
                    <a
                      href={d.href}
                      {...(d.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                    >
                      {d.value}
                    </a>
                  ) : (
                    d.value
                  )}
                </dd>
              </Reveal>
            ))}
          </dl>

          <Reveal className="contact__map" delay={0.15}>
            {consent.maps ? (
              <iframe
                src={COMPANY.mapsEmbed}
                title={t('contact.mapTitle')}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            ) : (
              <div className="map-placeholder">
                <p>{t('consent.mapText')}</p>
                <button type="button" className="btn btn--ghost btn--sm" onClick={() => consent.save({ maps: true })}>
                  {t('consent.mapShow')}
                </button>
              </div>
            )}
            <a href={COMPANY.mapsUrl} target="_blank" rel="noopener noreferrer" className="btn btn--accent btn--sm contact__nav">
              {t('contact.navigate')}
              <ArrowIcon />
            </a>
          </Reveal>
        </div>

        <div className="team">
          <Reveal as="h3" className="team__title" y={20}>
            {t('contact.team')}
          </Reveal>
          <ul className="team__grid">
            {TEAM.map((person, i) => (
              <Reveal as="li" key={person.email} className="team__card" delay={i * 0.07} y={30}>
                <span className="team__role">{t(`contact.roles.${person.role}`)}</span>
                <span className="team__name">{person.name}</span>
                <span className="team__links">
                  <a href={`tel:${person.phone.replace(/\s/g, '')}`}>{person.phone}</a>
                  <a href={`mailto:${person.email}`}>{person.email}</a>
                </span>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ContactDetails;
